app.controller('SimilarApartmentsSlickController',
	["$scope", function($scope) {
		$scope.slickBreakpoints = [
			{
				breakpoint: 640,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1
				}
			}
		];
	}]
);